var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondVectorBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.863 9.83C4.289 7.818 2.19 5.728.17 5.156c-.227-.073-.227-.233 0-.31C2.195 4.27 4.29 2.185 4.867.168c.062-.223.212-.223.274 0C5.715 2.184 7.812 4.27 9.83 4.846c.227.073.227.236 0 .31-2.021.57-4.12 2.661-4.693 4.675-.062.225-.212.225-.274 0z",
    fill: "#040222"
  })));
}
export default SvgDiamondVectorBlack;